export enum ModeratedContentStatus {
  Draft = 1,
  Pending = 2,
  DataRejected = 3,
  DataConfirmed = 4,
  Cancelled = -1,
}
